import type { Resource } from '../../';
export const forms_error_validEmail: Resource = {"default":"A valid {name} is required."};
